module.exports = __webpack_public_path__ + "images/icon-notebook-circle-56aa4148c33f69acf5a2d2a1c758c50d.png";